import React from 'react';
import { useParams } from 'react-router';
import { useQuestionnaireGroup, useQuestionnaireSections } from '@/features/constructor/hooks';
import { Group } from '@/features/constructorCommon';

export const QuestionnaireGroup = ({groupProp, sectionId, onCreated, ...props}) => {
  const { id } = useParams();
  const {
    handleUpdate,
    handleDelete,
    handleCreate,
    isCreating,
    isUpdating,
    isDeleting
  } = useQuestionnaireGroup({questionnaireId: id});
  const { dataSorted: dataSortedSections, loading: loadingSections, answers: dependentAnswers, setAnswers: setDependentAnswers } = useQuestionnaireSections(id, groupProp ? groupProp.visibleConditions : null);

  return (
    <Group groupProp={groupProp} sectionId={sectionId} onCreated={onCreated}
           handleUpdate={handleUpdate}
           handleDelete={handleDelete}
           handleCreate={handleCreate}
           isCreating={isCreating}
           isUpdating={isUpdating}
           isDeleting={isDeleting}
           dataSortedSections={dataSortedSections}
           loadingSections={loadingSections}
           dependentAnswers={dependentAnswers}
           setDependentAnswers={setDependentAnswers}
           type="questionnaire"
           {...props} />
  );
};
